"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getTransactions = exports.getServerInfo = exports.getAccountInfo = exports.submit = exports.parseAPIValue = exports.connectionTimeout = void 0;
var env_1 = require("../env");
var network_1 = __importDefault(require("../network"));
var currencies_1 = require("../currencies");
var promise_1 = require("../promise");
var js_1 = require("../families/ripple/bridge/js");
var defaultEndpoint = function () { return (0, env_1.getEnv)("API_RIPPLE_RPC"); };
exports.connectionTimeout = 30 * 1000; // default connectionTimeout is 2s and make the specs bot failed
var rippleUnit = (0, currencies_1.getCryptoCurrencyById)("ripple").units[0];
var parseAPIValue = function (value) {
    return (0, currencies_1.parseCurrencyUnit)(rippleUnit, value);
};
exports.parseAPIValue = parseAPIValue;
var submit = function (signature) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, network_1["default"])({
                    method: "POST",
                    url: "".concat(defaultEndpoint()),
                    data: {
                        method: "submit",
                        params: [
                            {
                                tx_blob: signature
                            },
                        ]
                    }
                })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data.result];
        }
    });
}); };
exports.submit = submit;
var getAccountInfo = function (recipient, current) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        res = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, network_1["default"])({
                            method: "POST",
                            url: "".concat(defaultEndpoint()),
                            data: {
                                method: "account_info",
                                params: [
                                    {
                                        account: recipient,
                                        ledger_index: current ? "current" : "validated"
                                    },
                                ]
                            }
                        })];
                    case 1:
                        res = _a.sent();
                        if (res.data.result.status !== "success" &&
                            res.data.result.error !== js_1.NEW_ACCOUNT_ERROR_MESSAGE) {
                            throw new Error("couldn't fetch account info ".concat(recipient));
                        }
                        return [2 /*return*/, res.data.result];
                }
            });
        }); };
        return [2 /*return*/, (0, promise_1.retry)(function () { return res(); }, {
                maxRetry: (0, env_1.getEnv)("GET_CALLS_RETRY")
            })];
    });
}); };
exports.getAccountInfo = getAccountInfo;
var getServerInfo = function (endpointConfig) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        res = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, network_1["default"])({
                            method: "POST",
                            url: endpointConfig !== null && endpointConfig !== void 0 ? endpointConfig : "".concat(defaultEndpoint()),
                            data: {
                                method: "server_info",
                                params: [
                                    {
                                        ledger_index: "validated"
                                    },
                                ]
                            }
                        })];
                    case 1:
                        res = _a.sent();
                        if (res.data.result.status !== "success") {
                            throw new Error("couldn't fetch server info");
                        }
                        return [2 /*return*/, res.data.result];
                }
            });
        }); };
        return [2 /*return*/, (0, promise_1.retry)(function () { return res(); }, {
                maxRetry: (0, env_1.getEnv)("GET_CALLS_RETRY")
            })];
    });
}); };
exports.getServerInfo = getServerInfo;
var getTransactions = function (address, options) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        res = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, network_1["default"])({
                            method: "POST",
                            url: "".concat(defaultEndpoint()),
                            data: {
                                method: "account_tx",
                                params: [
                                    __assign({ account: address, ledger_index: "validated" }, options),
                                ]
                            }
                        })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data.result.transactions];
                }
            });
        }); };
        return [2 /*return*/, (0, promise_1.retry)(function () { return res(); }, {
                maxRetry: (0, env_1.getEnv)("GET_CALLS_RETRY")
            })];
    });
}); };
exports.getTransactions = getTransactions;
function getLedgerIndex() {
    return __awaiter(this, void 0, void 0, function () {
        var res;
        var _this = this;
        return __generator(this, function (_a) {
            res = function () { return __awaiter(_this, void 0, void 0, function () {
                var ledgerResponse;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, network_1["default"])({
                                method: "POST",
                                url: "".concat(defaultEndpoint()),
                                data: {
                                    method: "ledger",
                                    params: [
                                        {
                                            ledger_index: "validated"
                                        },
                                    ]
                                }
                            })];
                        case 1:
                            ledgerResponse = _a.sent();
                            if (ledgerResponse.data.result.status !== "success") {
                                throw new Error("couldn't fetch getLedgerIndex");
                            }
                            return [2 /*return*/, ledgerResponse.data.result.ledger_index];
                    }
                });
            }); };
            return [2 /*return*/, (0, promise_1.retry)(function () { return res(); }, {
                    maxRetry: (0, env_1.getEnv)("GET_CALLS_RETRY")
                })];
        });
    });
}
exports["default"] = getLedgerIndex;
//# sourceMappingURL=Ripple.js.map